export default "__VITE_ASSET__CGVHX16M__"